<template>
  <div class="container">
    <vue-headful title="ABL Groupe | Realisations" />
    <h2>Pont CIUP, Paris</h2>
    <section class="realisation--section">
      <div class="realisation--description col-xs-12">

        <div class="description--content">
          <h3>Profilé spécial de main courante</h3>
          <div>
            <p>Section: 193 x 50mm</p>
            <p>Matière : S 355 JR</p>
            <p>Architecte : Bruno FORTIER</p>
          </div>
        </div>

        <img class="image--description" :src="require('../../assets/images/ciup.png')" alt="">
        </div>
        <div class="image--container col-xs-12">
          <div class="image--landscape">
            <img :src="require('../../assets/images/ciup-ret.jpg')"/>
          </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SpecialHandrailProfiles"
}
</script>

<style lang="scss" scoped>
.realisation--description {
  display: flex;
  .image--description {
    height: 300px;
    width: auto;
    object-fit: cover;
  }
}


.image--container {
  display: flex;
  flex-direction: row;

  .image--landscape {
    display: inherit;
    height: 500px;
    width: 100%;

    img {
      width: 100%;
      object-fit: cover;
    }
  }
}

</style>